import React from 'react';
import BillingPeriodRowProperties from "./BillingPeriodRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import BillingPeriodRowMedium from "./BillingPeriodRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import BillingPeriodRowSmall from "./BillingPeriodRowSmall";


const BillingPeriodRow: React.FC<BillingPeriodRowProperties> = ({
                                                      billingPeriod,
                                                      onUpdate
                                                  }) => {
    return (
        <>
            <ViewSmall>
                <BillingPeriodRowSmall onUpdate={onUpdate} billingPeriod={billingPeriod}/>
            </ViewSmall>
            <ViewMedium>
                <BillingPeriodRowMedium onUpdate={onUpdate} billingPeriod={billingPeriod} />
            </ViewMedium>
            <ViewLarge>
                <BillingPeriodRowMedium onUpdate={onUpdate} billingPeriod={billingPeriod} />
            </ViewLarge>
        </>
    )
}

export default BillingPeriodRow;
